module.exports = {
  title: '分类详情',
  route: {
    path: 'platform-goods-manage',
    children: {
      path: 'product-classify-form',
    },
  },
};
